import { useEffect } from 'react';

import { getFilterNavType } from 'src/tracking/utils/getFilterNavType';
import type { FilterNavType } from 'src/types/navigation';

export const useFilterNavType = (callback: (navType: FilterNavType) => void) => {
  useEffect(() => {
    callback(getFilterNavType());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
